import { IParsedMessage, TMessagesMap } from '../../types/messages';

interface ISetMessageReadStatusParams {
  messagesMap: TMessagesMap;
  messageIds: string[];
  chatMessages: IParsedMessage[];
}

/** Отмечает сообщения как прочитанные и обновляет чат и карту сообщений. */
export function setMessageReadStatus({ messagesMap, messageIds, chatMessages }: ISetMessageReadStatusParams) {
  if (messageIds.length === 0) {
    return chatMessages;
  }

  const nextChatMessages = [...chatMessages];

  messageIds.forEach(id => {
    // Получаем сообщение из карты по id
    const messageItem = messagesMap.get(id);

    if (messageItem) {
      const { message, messageIndex } = messageItem;

      const nextParseMessage: IParsedMessage = {
        ...message,
        message: {
          ...message.message,
          ...(message.message.isOutcoming ? { status: 'read' } : { isRead: true }),
        },
      };

      messagesMap.set(id, {
        messageIndex,
        message: nextParseMessage,
      });

      // Обновляем сообщение в копии массива чата
      if (nextChatMessages[messageIndex]) {
        nextChatMessages[messageIndex] = nextParseMessage;
      }
    }
  });

  return nextChatMessages;
}
